import React from 'react';
import { PlanSelector } from './PlanSelector';
export function Pricing() {
  return <section id="pricing" className="py-16 md:py-20 bg-navy-50" data-id="element-339">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-340">
        <div className="text-center mb-8 md:mb-10" data-id="element-341">
          <h2 className="text-3xl md:text-5xl font-extrabold text-navy-900 mb-3" data-id="element-342">
            ELEGÍ TU PLAN
          </h2>
          <p className="text-base md:text-lg text-slate-600" data-id="element-343">
            Seleccioná tu opción y comenzá hoy mismo.
          </p>
        </div>

        <PlanSelector variant="light" ctaLabel="QUIERO RECUPERAR EL CONTROL" data-id="element-344" />
      </div>
    </section>;
}